import * as types from 'modules/campaigns/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

export default createReducer(false, {
  [LOCATION_CHANGE]: () => false,
  [types.DETAILS_INITIALIZED]: () => true,
});
